import React from 'react'
import Cursor from '../Cursor/Cursor'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'


const Layout = (props) => {
  return (
      <div className="app">
        <Cursor/>
        <Header/>
            {props.children}
        <Footer />
      </div>
  )
}

export default Layout
